import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../images/logo/logo.png";
import "./style.css";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo(10, 0);
  };

  return (
    <footer className="tp-site-footer">
      <div className="tp-upper-footer">
        <div className="container">
          <div className="row gy-5">

            {/* About Section */}
            <div className="col-lg-4 col-md-6">
              <div className="widget about-widget">
                <div className="footer-logo widget-title">
                  <Link onClick={scrollToTop} to="/">
                    <img className='rounded-lg' src={Logo} alt="logo" />
                  </Link>
                </div>
                <p className="mt-3">
                 <b> Nardhanamala foundation</b> is dedicated to nurturing performing arts — dance, music,
                  and cultural education — among children, women, and communities.
                  Arts Accessible, Structured and Beneficial to All Ages.
                </p>
                <ul className="footer-socials mt-3">
                  <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                  <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="ti-twitter-alt"></i></a></li>
                  <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a></li>
                  <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><i className="ti-youtube"></i></a></li>
                </ul>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Quick Links</h3>
                </div>
                <ul>
                  <li><Link onClick={scrollToTop} to="/about">About Us</Link></li>
                  <li><Link onClick={scrollToTop} to="/causes">Our Programs</Link></li>
                  <li><Link onClick={scrollToTop} to="/volunteer">Volunteer</Link></li>
                  <li><Link onClick={scrollToTop} to="/focus">Focus</Link></li>
                  <li><Link onClick={scrollToTop} to="/contact">Contact</Link></li>
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="col-lg-4 col-md-6">
              <div className="widget contact-widget">
                <div className="widget-title">
                  <h3>Contact Us</h3>
                </div>
                <p>We’d love to hear from you! Reach out to know more or collaborate.</p>
                <ul className="contact-list">
                  <li><i className="fi flaticon-pin"></i>
                    Plot No. 107,
                    2nd Main Road,
                    Srinivasapuram,
                    Anagaputhur,
                    Chennai – 600070</li>
                  <li><i className="fi flaticon-call"></i> +91-9789990954</li>
                  <li><i className="fi flaticon-envelope"></i> nardhanamala@gmail.com</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="tp-lower-footer text-center">
        <div className="container">
          <p className="copyright">
            &copy; {new Date().getFullYear()} Nardhanamala Centre for Performing Arts Foundation. All Rights Reserved |
            Promoting Indian Performing Arts with Love & Grace.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
